import type { TZoneType } from '@opm/pages/ZoneTopCreatives/constants';
import type { IStudioEmbedLogConfig } from '@opm/utils/studioEmbedLog';
import type { IStudioTabPrNoticeMarqueeConfig } from '../StudioTabPrNoticeMarquee';

export type IMarketingStudioTabLogConfig = IStudioEmbedLogConfig;

export interface IAdCreativesTabConfig {
  key: string;
  nameEn: string;
  nameCn: string;
  /** 与 compConfig 注册的组件 name 一致，如 ZoneTopCreatives */
  name: string;
  componentProps?: Record<string, unknown>;
  logConfig?: IMarketingStudioTabLogConfig;
  /** Tab 级跑马灯；未配置或 textEn/textZh 均为空时不展示 */
  prNoticeMarquee?: IStudioTabPrNoticeMarqueeConfig;
}

export interface IAdCreativesWrapperConfig {
  queryKey?: string;
  defaultTab?: string;
  titleEn?: string;
  titleCn?: string;
  descriptionEn?: string;
  descriptionCn?: string;
  /** 传入 marketing filter/cond 的 game_ids，各 Tab 可经 componentProps 覆盖 */
  condGameIds?: string[];
  tabs: IAdCreativesTabConfig[];
}

export interface IZoneTopCreativesStudioProps {
  zoneType?: TZoneType;
  titleEn?: string;
  titleCn?: string;
  enableSourcePageLog?: boolean;
  hideGameCategoryTabs?: boolean;
  hidePageHeader?: boolean;
  defaultFilter?: Record<string, unknown>;
  filterInstanceId?: string;
  studioLogConfig?: IStudioEmbedLogConfig;
  condGameIds?: string[];
}

export interface ICompetitorAdComparisonStudioProps {
  titleEn?: string;
  titleCn?: string;
  enableSourcePageLog?: boolean;
  hidePageHeader?: boolean;
  hideGameCategoryTabs?: boolean;
  defaultFilter?: Record<string, unknown>;
  filterInstanceId?: string;
  studioLogConfig?: IStudioEmbedLogConfig;
  condGameIds?: string[];
}
export const STUDIO_AD_CREATIVES_FILTER_INSTANCE_PREFIX = 'studio-ad-creatives';

export function getStudioAdCreativesFilterInstanceId(tabKey: string) {
  return `${STUDIO_AD_CREATIVES_FILTER_INSTANCE_PREFIX}-${tabKey}`;
}
